import React, { useState } from 'react';
import Logo from '../static/images/ss-original.png';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from "react-router-dom";
import {resetPassword} from "../../Services/ApiCallsServices/AuthenticationApi";

const ResetPassword = () => {
    const { uid, token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const showPassword = useState(false); // Corrected initialization
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handlePasswordReset = async () => {
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        try {
            await resetPassword(uid, token, password);
            setMessage('Password reset successful!');
            navigate("/login");
        } catch (error) {
            setError(error.message || 'Failed to reset password. Please try again.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Reset Password | Storage Sprint</title>
            </Helmet>
            <div className="ResetPassword-body">
                <div className="reset-password-container">
                    <div className="password-reset-form">
                        <img src={Logo} alt="Storage Sprint Logo" className="logo"/>
                        <h2 className="slogan">Reset Password</h2>

                        {message && <p className="message">{message}</p>}
                        {error && <div className="error">{error}</div>}


                        <div className="reset-password-form">
                            <label>New Password</label>
                            <div className="input-container">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <label>Confirm Password</label>
                            <div className="input-container">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                            <button onClick={handlePasswordReset}>Continue</button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
